import PropTypes from 'prop-types';
/**
 * Created by marks on 24.01.2017.
 */
import React from 'react';

const styles = {
  //default styles
  spinner: {
    animation: 'rotate 2s linear infinite',
    background: 'transparent',
    borderWidth: '5px',
    borderStyle: 'solid',
    ////////////////////////// Переназначается стилями:
    ////////////////////////// Web2/src_js/MnJsPlatform.UI.Components/lib/common/MnSpinner.js
    ////////////////////////// Web2/src_js/AssetsWeb/css/themes/layout.scss
    ////////////////////////// #root>.-fixmenu>div>[style*="animation"]
    borderColor: 'rgba(130, 130, 130, .8)',
    borderLeftColor: 'rgba(130, 130, 130, .2)',
    ///////////////////////////////////////////
    borderRadius: '100%',
    margin: 'auto',
    marginTop: '-20px',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '40px',
    width: '40px'
  },
  container: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    height: '100%',
    zIndex: 200000//,
    //background: 'rgba(0, 0, 0, 0.2)'
  }
};

export default class Spinner extends React.Component {

  componentDidMount() {
    this.addAnimationRules();
  }

  addAnimationRules() {
    let stylesheet = document.styleSheets[0];
    let styleEl;
    if (!stylesheet) {
      styleEl = document.createElement('style');
      document.head.appendChild(styleEl);
      stylesheet = styleEl.sheet;
    }

    const animationName = 'rotate';
    const fromRule = 'rotate(0deg)';
    const toRule = 'rotate(360deg)';
    const propName = 'transform';

    if (CSSRule.WEBKIT_KEYFRAMES_RULE) {
      stylesheet.insertRule(`@-webkit-keyframes ${animationName} {from{-webkit-${propName}: ${fromRule};} to {-webkit-${propName}: ${toRule};}}`, 0);
    } else if (CSSRule.MOZ_KEYFRAMES_RULE) {
      stylesheet.insertRule(`@-moz-keyframes ${animationName} {from{-moz-${propName}: ${fromRule};} to {-moz-${propName}: ${toRule};}}`, 0);
    } else if (CSSRule.MS_KEYFRAMES_RULE) {
      stylesheet.insertRule(`@-ms-keyframes ${animationName} {from{-ms-${propName}: ${fromRule};} to {-ms-${propName}: ${toRule};}}`, 0);
    } else {
      stylesheet.insertRule(`@keyframes ${animationName} {from{${propName}: ${fromRule};} to {${propName}: ${toRule};}}`, 0);
    }
  }

  /*
   * Convert hex color code to RGB
   * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
   */
  hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  render() {
    const spinnerStyle = Object.assign({}, styles.spinner);
    const containerStyle = this.props.containerStyle ? Object.assign({}, this.props.containerStyle) : Object.assign({}, styles.container);

    if (this.props.colorHex) {
      const borderRGB = this.hexToRgb(this.props.colorHex);
      if (borderRGB) {
        spinnerStyle.borderColor = `rgba(${borderRGB.r}, ${borderRGB.g}, ${borderRGB.b}, .7)`;
        spinnerStyle.borderLeftColor = `rgba(${borderRGB.r}, ${borderRGB.g}, ${borderRGB.b}, .3)`;
      }
    }

    if (this.props.size) {
      spinnerStyle.height = this.props.size;
      spinnerStyle.width = this.props.size;
      spinnerStyle.marginTop = `-${parseInt(this.props.size, 10) / 2}px`;
    }

    if (this.props.spinnerWidth) {
      spinnerStyle.borderWidth = this.props.spinnerWidth;
    }

    if (this.props.borderStyle) {
      spinnerStyle.borderStyle = this.props.borderStyle;
    }

    if (this.props.spinDuration) {
      spinnerStyle.animationDuration = `${this.props.spinDuration}s`;
    }

    return (
      <div id={"spinner-container"} style={containerStyle}>
        <div style={spinnerStyle}></div>
      </div>
    );
  }
}

Spinner.propTypes = {
  colorHex: PropTypes.string,
  spinnerWidth: PropTypes.string,
  spinDuration: PropTypes.number,
  borderStyle: PropTypes.string,
  size: PropTypes.string,
  containerStyle: PropTypes.object
};
